//Have I seen the modal?
export function getSeenModalFromLocalstorage() {
  return window.localStorage.getItem("hasSeenEmailModal")
}
//Set that I've seen the modal
export function setSeenModalInLocalstorage() {
  window.localStorage.setItem("hasSeenEmailModal", true)
}


//Have I opted in before?
export function getHasSignedUpFromLocalstorage() {
  return window.localStorage.getItem("hasSignedUpFromEmailModal")
}
//Set that I have opted in
export function setHasSignedUpInLocalstorage() {
  window.localStorage.setItem("hasSignedUpFromEmailModal", true)
}


// WEBPACK FOOTER //
// ./src/battle-optin/optin-localstorage-operations.js